module.exports = __webpack_public_path__ + "img/upload_info_m.96bd46a3.svg";